module.exports = __webpack_public_path__ + "img/Lithuania.0c009ce4.svg";